"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _ActionPlan = _interopRequireDefault(require("../model/ActionPlan"));

var _ActionPlanCreateRequest = _interopRequireDefault(require("../model/ActionPlanCreateRequest"));

var _ActionPlanList = _interopRequireDefault(require("../model/ActionPlanList"));

var _ActionPlanStep = _interopRequireDefault(require("../model/ActionPlanStep"));

var _ActionPlanStepList = _interopRequireDefault(require("../model/ActionPlanStepList"));

var _ActionPlanStepUpdateRequest = _interopRequireDefault(require("../model/ActionPlanStepUpdateRequest"));

var _ActionPlanUpdateRequest = _interopRequireDefault(require("../model/ActionPlanUpdateRequest"));

var _AddActionToPlanRequest = _interopRequireDefault(require("../model/AddActionToPlanRequest"));

var _Errors = _interopRequireDefault(require("../model/Errors"));

var _StatusEnum = _interopRequireDefault(require("../model/StatusEnum"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
* ActionPlans service.
* @module api/ActionPlansApi
* @version 1.126
*/
var ActionPlansApi = /*#__PURE__*/function () {
  /**
  * Constructs a new ActionPlansApi. 
  * @alias module:api/ActionPlansApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function ActionPlansApi(apiClient) {
    _classCallCheck(this, ActionPlansApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Insert a new step to an existing action plan
   * **scope**: action-plans:write 
   * @param {String} planUuid 
   * @param {Object} opts Optional parameters
   * @param {module:model/AddActionToPlanRequest} opts.addActionToPlanRequest The parameters of the REST action
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ActionPlanStep} and HTTP response
   */


  _createClass(ActionPlansApi, [{
    key: "appApisV1ActionPlansAddStepToActionPlanWithHttpInfo",
    value: function appApisV1ActionPlansAddStepToActionPlanWithHttpInfo(planUuid, opts) {
      opts = opts || {};
      var postBody = opts['addActionToPlanRequest']; // verify the required parameter 'planUuid' is set

      if (planUuid === undefined || planUuid === null) {
        throw new Error("Missing the required parameter 'planUuid' when calling appApisV1ActionPlansAddStepToActionPlan");
      }

      var pathParams = {
        'plan_uuid': planUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ActionPlanStep["default"];
      return this.apiClient.callApi('/action-plans/{plan_uuid}/steps', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Insert a new step to an existing action plan
     * **scope**: action-plans:write 
     * @param {String} planUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/AddActionToPlanRequest} opts.addActionToPlanRequest The parameters of the REST action
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ActionPlanStep}
     */

  }, {
    key: "appApisV1ActionPlansAddStepToActionPlan",
    value: function appApisV1ActionPlansAddStepToActionPlan(planUuid, opts) {
      return this.appApisV1ActionPlansAddStepToActionPlanWithHttpInfo(planUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Create a new purchase order action plan
     * **scope**: action-plans:write 
     * @param {module:model/ActionPlanCreateRequest} actionPlanCreateRequest The payload to use to create the new purchase order action plan
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ActionPlan} and HTTP response
     */

  }, {
    key: "appApisV1ActionPlansCreateActionPlanWithHttpInfo",
    value: function appApisV1ActionPlansCreateActionPlanWithHttpInfo(actionPlanCreateRequest) {
      var postBody = actionPlanCreateRequest; // verify the required parameter 'actionPlanCreateRequest' is set

      if (actionPlanCreateRequest === undefined || actionPlanCreateRequest === null) {
        throw new Error("Missing the required parameter 'actionPlanCreateRequest' when calling appApisV1ActionPlansCreateActionPlan");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ActionPlan["default"];
      return this.apiClient.callApi('/action-plans', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Create a new purchase order action plan
     * **scope**: action-plans:write 
     * @param {module:model/ActionPlanCreateRequest} actionPlanCreateRequest The payload to use to create the new purchase order action plan
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ActionPlan}
     */

  }, {
    key: "appApisV1ActionPlansCreateActionPlan",
    value: function appApisV1ActionPlansCreateActionPlan(actionPlanCreateRequest) {
      return this.appApisV1ActionPlansCreateActionPlanWithHttpInfo(actionPlanCreateRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Delete a purchase order action plan
     * **scope**: action-plans:admin 
     * @param {String} planUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1ActionPlansDeleteActionPlanWithHttpInfo",
    value: function appApisV1ActionPlansDeleteActionPlanWithHttpInfo(planUuid) {
      var postBody = null; // verify the required parameter 'planUuid' is set

      if (planUuid === undefined || planUuid === null) {
        throw new Error("Missing the required parameter 'planUuid' when calling appApisV1ActionPlansDeleteActionPlan");
      }

      var pathParams = {
        'plan_uuid': planUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/action-plans/{plan_uuid}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Delete a purchase order action plan
     * **scope**: action-plans:admin 
     * @param {String} planUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1ActionPlansDeleteActionPlan",
    value: function appApisV1ActionPlansDeleteActionPlan(planUuid) {
      return this.appApisV1ActionPlansDeleteActionPlanWithHttpInfo(planUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get a purchase order action plan
     * **scope**: action-plans:read 
     * @param {String} planUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ActionPlan} and HTTP response
     */

  }, {
    key: "appApisV1ActionPlansGetActionPlanWithHttpInfo",
    value: function appApisV1ActionPlansGetActionPlanWithHttpInfo(planUuid) {
      var postBody = null; // verify the required parameter 'planUuid' is set

      if (planUuid === undefined || planUuid === null) {
        throw new Error("Missing the required parameter 'planUuid' when calling appApisV1ActionPlansGetActionPlan");
      }

      var pathParams = {
        'plan_uuid': planUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ActionPlan["default"];
      return this.apiClient.callApi('/action-plans/{plan_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get a purchase order action plan
     * **scope**: action-plans:read 
     * @param {String} planUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ActionPlan}
     */

  }, {
    key: "appApisV1ActionPlansGetActionPlan",
    value: function appApisV1ActionPlansGetActionPlan(planUuid) {
      return this.appApisV1ActionPlansGetActionPlanWithHttpInfo(planUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get a step from an action plan
     * **scope**: action-plans:read 
     * @param {String} planUuid 
     * @param {String} stepUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ActionPlanStep} and HTTP response
     */

  }, {
    key: "appApisV1ActionPlansGetActionPlanStepWithHttpInfo",
    value: function appApisV1ActionPlansGetActionPlanStepWithHttpInfo(planUuid, stepUuid) {
      var postBody = null; // verify the required parameter 'planUuid' is set

      if (planUuid === undefined || planUuid === null) {
        throw new Error("Missing the required parameter 'planUuid' when calling appApisV1ActionPlansGetActionPlanStep");
      } // verify the required parameter 'stepUuid' is set


      if (stepUuid === undefined || stepUuid === null) {
        throw new Error("Missing the required parameter 'stepUuid' when calling appApisV1ActionPlansGetActionPlanStep");
      }

      var pathParams = {
        'plan_uuid': planUuid,
        'step_uuid': stepUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ActionPlanStep["default"];
      return this.apiClient.callApi('/action-plans/{plan_uuid}/steps/{step_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get a step from an action plan
     * **scope**: action-plans:read 
     * @param {String} planUuid 
     * @param {String} stepUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ActionPlanStep}
     */

  }, {
    key: "appApisV1ActionPlansGetActionPlanStep",
    value: function appApisV1ActionPlansGetActionPlanStep(planUuid, stepUuid) {
      return this.appApisV1ActionPlansGetActionPlanStepWithHttpInfo(planUuid, stepUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get the steps list of an existing action plan
     * **scope**: action-plans:read 
     * @param {String} planUuid 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ActionPlanStepList} and HTTP response
     */

  }, {
    key: "appApisV1ActionPlansListActionPlanStepsWithHttpInfo",
    value: function appApisV1ActionPlansListActionPlanStepsWithHttpInfo(planUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'planUuid' is set

      if (planUuid === undefined || planUuid === null) {
        throw new Error("Missing the required parameter 'planUuid' when calling appApisV1ActionPlansListActionPlanSteps");
      }

      var pathParams = {
        'plan_uuid': planUuid
      };
      var queryParams = {
        'page': opts['page'],
        'per_page': opts['perPage']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ActionPlanStepList["default"];
      return this.apiClient.callApi('/action-plans/{plan_uuid}/steps', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get the steps list of an existing action plan
     * **scope**: action-plans:read 
     * @param {String} planUuid 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ActionPlanStepList}
     */

  }, {
    key: "appApisV1ActionPlansListActionPlanSteps",
    value: function appApisV1ActionPlansListActionPlanSteps(planUuid, opts) {
      return this.appApisV1ActionPlansListActionPlanStepsWithHttpInfo(planUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get a paginated list of purchase order action plan
     * **scope**: action-plans:read 
     * @param {Object} opts Optional parameters
     * @param {module:model/StatusEnum} opts.observedState 
     * @param {String} opts.deliverUuid Deliver uuid
     * @param {String} opts.locationUuid Location uuid
     * @param {Boolean} opts.withSteps Purchase order actions should be included within a page's action plan list
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ActionPlanList} and HTTP response
     */

  }, {
    key: "appApisV1ActionPlansListActionPlansWithHttpInfo",
    value: function appApisV1ActionPlansListActionPlansWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'observed_state': opts['observedState'],
        'deliver_uuid': opts['deliverUuid'],
        'location_uuid': opts['locationUuid'],
        'with_steps': opts['withSteps'],
        'page': opts['page'],
        'per_page': opts['perPage']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ActionPlanList["default"];
      return this.apiClient.callApi('/action-plans', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get a paginated list of purchase order action plan
     * **scope**: action-plans:read 
     * @param {Object} opts Optional parameters
     * @param {module:model/StatusEnum} opts.observedState 
     * @param {String} opts.deliverUuid Deliver uuid
     * @param {String} opts.locationUuid Location uuid
     * @param {Boolean} opts.withSteps Purchase order actions should be included within a page's action plan list
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ActionPlanList}
     */

  }, {
    key: "appApisV1ActionPlansListActionPlans",
    value: function appApisV1ActionPlansListActionPlans(opts) {
      return this.appApisV1ActionPlansListActionPlansWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Remove a step from an action plan
     * **scope**: action-plans:write 
     * @param {String} planUuid 
     * @param {String} stepUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1ActionPlansRemoveStepFromActionPlanWithHttpInfo",
    value: function appApisV1ActionPlansRemoveStepFromActionPlanWithHttpInfo(planUuid, stepUuid) {
      var postBody = null; // verify the required parameter 'planUuid' is set

      if (planUuid === undefined || planUuid === null) {
        throw new Error("Missing the required parameter 'planUuid' when calling appApisV1ActionPlansRemoveStepFromActionPlan");
      } // verify the required parameter 'stepUuid' is set


      if (stepUuid === undefined || stepUuid === null) {
        throw new Error("Missing the required parameter 'stepUuid' when calling appApisV1ActionPlansRemoveStepFromActionPlan");
      }

      var pathParams = {
        'plan_uuid': planUuid,
        'step_uuid': stepUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/action-plans/{plan_uuid}/steps/{step_uuid}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Remove a step from an action plan
     * **scope**: action-plans:write 
     * @param {String} planUuid 
     * @param {String} stepUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1ActionPlansRemoveStepFromActionPlan",
    value: function appApisV1ActionPlansRemoveStepFromActionPlan(planUuid, stepUuid) {
      return this.appApisV1ActionPlansRemoveStepFromActionPlanWithHttpInfo(planUuid, stepUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update a purchase order action plan
     * **scope**: action-plans:write 
     * @param {String} planUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/ActionPlanUpdateRequest} opts.actionPlanUpdateRequest The payload to use to update the request purchase order action plan
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ActionPlan} and HTTP response
     */

  }, {
    key: "appApisV1ActionPlansUpdateActionPlanWithHttpInfo",
    value: function appApisV1ActionPlansUpdateActionPlanWithHttpInfo(planUuid, opts) {
      opts = opts || {};
      var postBody = opts['actionPlanUpdateRequest']; // verify the required parameter 'planUuid' is set

      if (planUuid === undefined || planUuid === null) {
        throw new Error("Missing the required parameter 'planUuid' when calling appApisV1ActionPlansUpdateActionPlan");
      }

      var pathParams = {
        'plan_uuid': planUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ActionPlan["default"];
      return this.apiClient.callApi('/action-plans/{plan_uuid}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update a purchase order action plan
     * **scope**: action-plans:write 
     * @param {String} planUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/ActionPlanUpdateRequest} opts.actionPlanUpdateRequest The payload to use to update the request purchase order action plan
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ActionPlan}
     */

  }, {
    key: "appApisV1ActionPlansUpdateActionPlan",
    value: function appApisV1ActionPlansUpdateActionPlan(planUuid, opts) {
      return this.appApisV1ActionPlansUpdateActionPlanWithHttpInfo(planUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update a step of an action plan
     * **scope**: action-plans:write 
     * @param {String} planUuid 
     * @param {String} stepUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/ActionPlanStepUpdateRequest} opts.actionPlanStepUpdateRequest The payload to use to update a step of a purchase order action plan
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ActionPlanStep} and HTTP response
     */

  }, {
    key: "appApisV1ActionPlansUpdateActionPlanStepWithHttpInfo",
    value: function appApisV1ActionPlansUpdateActionPlanStepWithHttpInfo(planUuid, stepUuid, opts) {
      opts = opts || {};
      var postBody = opts['actionPlanStepUpdateRequest']; // verify the required parameter 'planUuid' is set

      if (planUuid === undefined || planUuid === null) {
        throw new Error("Missing the required parameter 'planUuid' when calling appApisV1ActionPlansUpdateActionPlanStep");
      } // verify the required parameter 'stepUuid' is set


      if (stepUuid === undefined || stepUuid === null) {
        throw new Error("Missing the required parameter 'stepUuid' when calling appApisV1ActionPlansUpdateActionPlanStep");
      }

      var pathParams = {
        'plan_uuid': planUuid,
        'step_uuid': stepUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ActionPlanStep["default"];
      return this.apiClient.callApi('/action-plans/{plan_uuid}/steps/{step_uuid}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update a step of an action plan
     * **scope**: action-plans:write 
     * @param {String} planUuid 
     * @param {String} stepUuid 
     * @param {Object} opts Optional parameters
     * @param {module:model/ActionPlanStepUpdateRequest} opts.actionPlanStepUpdateRequest The payload to use to update a step of a purchase order action plan
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ActionPlanStep}
     */

  }, {
    key: "appApisV1ActionPlansUpdateActionPlanStep",
    value: function appApisV1ActionPlansUpdateActionPlanStep(planUuid, stepUuid, opts) {
      return this.appApisV1ActionPlansUpdateActionPlanStepWithHttpInfo(planUuid, stepUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);

  return ActionPlansApi;
}();

exports["default"] = ActionPlansApi;